import { AbstractControl } from '@angular/forms';

// export function emailValidator(control: AbstractControl): { [key: string]: any } | null {
//   const valid = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(control.value)
//   return valid ? null : { invalidEmail: { valid: false, value: control.value } };
// }

export function urlValidator(control: AbstractControl): { [key: string]: any } | null {
  const valid = /^(http|https):[^s]*?/.test(control.value);
  return valid ? null : { invalidUrl: { valid: false, value: control.value } };
}

export function phoneNumberValidator(control: AbstractControl): { [key: string]: any } | null {
  const valid = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/gm.test(control.value);
    ///^\d+$/.test(control.value);
  return valid ? null : { invalidNumber: { valid: false, value: control.value } };
}


export function emailValidator(control: AbstractControl) {
  const valid = /^.+\@.+\..+$/.test(control.value);
   return valid ? null : { invalidEmail: { valid: false, value: control.value } };
}
